<template>
  <div v-if="active" class="message-fixed">
    <div class="message-flex">
      <div class="message-title">{{ title }}</div>
      <div v-if="type !== 'ic'" class="message-body" v-html="body"></div>
      <div v-if="type === 'ic' || type === 'cred_kz'" class="message-body">
        <p>Благодарим Вас за выбор компании «МАКС-Жизнь».</p>
        <p>Для оплаты страховой премии по договору страхования, пожалуйста, перейдите на страницу оплаты, нажав кнопку
          «Оплатить».</p>
        <div v-if="type === 'ic'" class="autopay">
          <div class="text-size-14">Подключая автоплатеж, принимаю условия <a
            href="https://makclife.ru/upload/medialibrary/806/%D0%A1%D0%BE%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5%D0%A0%D0%B5%D0%B3%D1%83%D0%BB%D1%8F%D1%80%D0%BD%D1%8B%D0%B5%D0%A1%D0%BF%D0%B8%D1%81%D0%B0%D0%BD%D0%B8%D1%8F.pdf"
            target="_blank"
          >Соглашения о проведении регулярных платежей</a>
          </div>
          <input :disabled="!params['pk']" type="checkbox" name="autopay" v-model="autoPay">
          <span>Подключить автоплатеж</span>
          <div class="autopay-desc">Списание платежей будет осуществляться автоматически в соответствии с графиком
            платежей по договору.
          </div>
        </div>
        <div v-for="(param, idx) in params" :key="idx" class="pays">
          <div v-if="param.type === 'tkb' && autoPay">
            <div class="card-pay">
              <a :href="param.link" target="_blank"><strong>Оплатить</strong></a>
            </div>
          </div>
          <div v-if="param.type === 'pk' && !autoPay">
            <div class="card-pay">
              <a :href="param.link" target="_blank"><strong>Оплатить</strong></a>
            </div>
          </div>
          <div class="qr-pay" v-if="param.type === 'pk'">
            <a v-if="!isMobile" target="_blank" :href="param.qr_link">
              <svg v-if="!isMobile" role="img" aria-label="qr_code" class="qr_code" viewBox="0 0 219 200" width="128px"
                   height="128px">
                <g>
                  <image id="blink" x="15" y="0" :xlink:href="param.qr_code" />
                </g>
              </svg>
            </a>
            <p v-if="!isMobile" class="qr-text">Оплата через СБП</p>
            <a class="invoice-mob" target="_blank" v-if="isMobile" :href="param.qr_link">Оплатить СБП(QR)</a>
          </div>
        </div>
      </div>
      <br />
      <button @click.prevent="next">Продолжить</button>
      <br /><br />
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalComponent",
  props: ["title", "body", "contract_id", "active", "type", "params"],
  data: function() {
    return {
      autoPay: !!this.params.tkb
    };
  },
  methods: {
    next() {
      // this.$router.push({ name: 'contract', params: { id: this.contract_id } });
      window.location.href = "".concat("/profile/contract/", this.contract_id);
    }
  },
  computed: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i
        .test(navigator.userAgent)) {
        return true;
      } else return false;
    }
  }
};
</script>

<style scoped>
.pays {
  display: flex;
  justify-content: space-around;
}

.card-pay a, .qr-pay a.invoice-mob {
  padding: .7em;
  float: none;
  color: #fff !important;
  background: #004b88;
  font-size: 14pt;
  font-weight: 600;
  display: block;
  width: fit-content;
  text-decoration: none;
  margin: 15px auto auto;
  white-space: nowrap;
}

.card-pay a:hover, .qr-pay a.invoice-mob:hover {
  background: #008cff;
  color: #fff;
  border-bottom: none;
}

.message-fixed {
  position: fixed;
  z-index: 40;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(33, 35, 37, .5);
  overflow: auto;
}

.message-flex {
  padding: 41px 40px 40px;
  width: 558px;
  background: #fff;
  margin: 30vh auto;
}

.message-title {
  font-size: 20px;
  color: #212325;
}

.message-body {
  font-size: 16px;
  font-weight: 400;
  color: #212325;
  text-align: justify;
}

.message-flex button {
  padding: 10px;
  background: #0062cc;
  color: #FFFFFF;
  border: 2px solid #005cbf;
  outline: #0075D4;
  cursor: pointer;
  font: 700 20px SourceSansPro, sans-serif;
  border-radius: .3rem;
}

@media screen and (max-width: 720px) {
  .message-flex {
    width: 100vw;
  }
}
</style>